export default __webpack_public_path__ + "997a16aa51e790bfc8dce9d35378cfaf.png";